import React from 'react';
import {
  Box, Skeleton, Stack, Typography,
} from '@mui/material';
import { TripMatch, TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { ChipOption, InfiniteScroll } from '@marageti/z4-lib';
import AllCard from '../list-cards/trip-match-cards/all-card-traveler-page';
import { canceledStatusesValue } from '../../hooks/use-trip-match-search';

export const statusChipOptions: ChipOption[] = [
  { key: 0, label: 'New', value: TripMatchStatus.MatchPending },
  { key: 1, label: 'Accepted', value: TripMatchStatus.MatchAccepted },
  { key: 2, label: 'Active', value: TripMatchStatus.MatchActive },
  { key: 3, label: 'Sold', value: TripMatchStatus.MatchSold },
  { key: 4, label: 'Partner Declined', value: TripMatchStatus.MatchPartnerDeclined },
  { key: 5, label: 'Postponed', value: TripMatchStatus.MatchPostponed },
  { key: 6, label: 'Inactive', value: TripMatchStatus.MatchInactive },
  { key: 7, label: 'Canceled', value: canceledStatusesValue },
];

type TravelerTripsViewProps = {
  error?: ApiError,
  hasMoreItems: boolean,
  isLoading: boolean,
  items?: TripMatch[],
  loadMore: () => void,
  totalHits: string,
};

const TravelerTripsView = ({
  error = undefined,
  hasMoreItems,
  isLoading,
  items = undefined,
  loadMore,
  totalHits,
}: TravelerTripsViewProps) => (
  <Box>
    {isLoading ? (
      <Skeleton variant="rounded" sx={{ mb: 2, height: '24px', width: '100px' }} />
    ) : (
      <Typography variant="bodyBold" mb={2}>
        {`Trip Matches (${totalHits})`}
      </Typography>
    )}
    <Stack spacing={1}>
      <InfiniteScroll
        error={error}
        hasMoreItems={hasMoreItems}
        isLoading={isLoading}
        loadMoreItems={loadMore}
      >
        {items?.flatMap((item: TripMatch) => (
          <AllCard
            key={item.id}
            tripMatch={item}
          />
        ))}
      </InfiniteScroll>
    </Stack>
  </Box>
);

export default TravelerTripsView;
